export const getApiData = (
    url: string,
    setLoading: (loading: boolean) => void,
    setData: (data: any) => void,
    setErrorMessage: (errorMessage: string) => void,
    notFoundMessage?: string) => {

    setLoading(true);

    fetch(url, {
        method: "GET",
        headers: {
            "Cache-Control": "no-cache",
            pragma: "no-cache"
        }
    })
        .then(response => {
            if (response.status === 404) {
                setErrorMessage((notFoundMessage ? notFoundMessage : "No data found."));
            }
            else if (!response.ok) {
                response.text().then(text => {
                    if (text !== "")
                        setErrorMessage(text);
                    else
                        setErrorMessage("Fetch failed (" + response.statusText + ").");
                });
            } else {
                response.json().then(data => {
                    setData(data);
                });
            }
            setLoading(false);
        })
        .catch(error => {
            setErrorMessage(error.message);
            setLoading(false);
        });

}